//! PLEASE keep this list in alphabetical order for a better readability
export enum BROADCASTS {
    /**
     * @value Pick a specific date and time to broadcast the resource to your audience.
     * @description A helper text so the user knows what the date she picks is used for
     *
     * Here a "resource" can be a website URL, an article, etc. something that can be opened and read by a user.
     *
     * An "audience" is a set of people to which we send a communication (an email, a notification, etc.)
     */
    ABSOLUTE_DATE_HELPER = 'BROADCASTS.ABSOLUTE_DATE_HELPER',
    /**
     * @value The audience size is likely to evolve until the scheduled sending date.
     */
    AUDIENCE_MIGHT_EVOLVE = 'BROADCASTS.AUDIENCE_MIGHT_EVOLVE',
    /**
     * @value Use a campaign baseline date to schedule your broadcast based on this event (e.g. 3 days before the Corporate offsite).
     * @description Description for the "Send relatively to a baseline date" option
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people
     *
     * A baseline date is a date that is set and can be used as a base to define another date.
     *
     * For example a baseline date can be a project's start date (for example, 10th of August). You could use this as a base date to define a meeting date which is one week after the project start date (which would be the 17th of August for our example).
     */
    BASELINE_DATE_HELPER = 'BROADCASTS.BASELINE_DATE_HELPER',
    /**
     * @value Broadcast archived
     * @description "Broadcast" is a product name, it should not be translated
     */
    BROADCAST_ARCHIVED = 'BROADCASTS.BROADCAST_ARCHIVED',
    /**
     * @value Target the right audience.
     * @description An "audience" is a set of people to which we send a communication (an email, a notification, etc.)
     */
    BROADCAST_AUDIENCE_DESCRIPTION = 'BROADCASTS.BROADCAST_AUDIENCE_DESCRIPTION',
    /**
     * @value Identify your audience
     * @description An "audience" is a set of people to which we send a communication (an email, a notification, etc.)
     */
    BROADCAST_AUDIENCE_TITLE = 'BROADCASTS.BROADCAST_AUDIENCE_TITLE',
    /**
     * @value Broadcast deleted
     * @description Notification message to display after the broadcast has been successfully deleted
     *
     * "Broadcast" is a product name, it should not be translated
     */
    BROADCAST_DELETED = 'BROADCASTS.BROADCAST_DELETED',
    /**
     * @value Broadcast duplicated
     * @description Notification message to display after the broadcast has been successfull duplicated
     *
     * "Broadcast" is a product name, it should not be translated
     */
    BROADCAST_DUPLICATED = 'BROADCASTS.BROADCAST_DUPLICATED',
    /**
     * @value Broadcast saved
     * @description Notification message to display after the broadcast has been successfully saved
     *
     * "Broadcast" is a product term, it should not be translated
     */
    BROADCAST_SAVED = 'BROADCASTS.BROADCAST_SAVED',
    /**
     * @value Broadcast scheduled
     * @description Notification message to display after the broadcast has been successfull scheduled
     *
     * "Broadcast" is a product name, it should not be translated
     */
    BROADCAST_SCHEDULED = 'BROADCASTS.BROADCAST_SCHEDULED',
    /**
     * @value Broadcast name
     * @description "Broadcast" is a product name, it should not be translated
     */
    BROADCAST_TITLE = 'BROADCASTS.BROADCAST_TITLE',
    /**
     * @value Broadcast unarchived
     * @description "Broadcast" is a product name, it should not be translated
     *
     * Here "unarchived" is a confirmation that the action of unarchiving has been done
     */
    BROADCAST_UNARCHIVED = 'BROADCASTS.BROADCAST_UNARCHIVED',
    /**
     * @value %TITLE% will be sent:
     */
    BROADCAST_WILL_BE_SENT = 'BROADCASTS.BROADCAST_WILL_BE_SENT',
    /**
     * @value Select a campaign
     * @description Placeholder for the select input to pick a campaign for the current broadcast
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     */
    CAMPAIGN_FIELD_PLACEHOLDER = 'BROADCASTS.CAMPAIGN_FIELD_PLACEHOLDER',
    /**
     * @value Create from scratch
     * @description Menu option to create a broadcast from scratch (not from a template).
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     *
     */
    CREATE_FROM_SCRATCH = 'BROADCASTS.CREATE_FROM_SCRATCH',
    /**
     * @value Create from template
     * @description Menu option to create a broadcast from template (not from scratch).
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    CREATE_FROM_TEMPLATE = 'BROADCASTS.CREATE_FROM_TEMPLATE',
    /**
     * @value The broadcast %NAME% will be permanently deleted. This action cannot be reverted.
     * @description "Broadcast" is a product name, it should not be translated
     */
    DELETE_CONFIRMATION_DESCRIPTION = 'BROADCASTS.DELETE_CONFIRMATION_DESCRIPTION',
    /**
     * @value Delete broadcast?
     * @description "Broadcast" is a product name, it should not be translated
     */
    DELETE_CONFIRMATION_TITLE = 'BROADCASTS.DELETE_CONFIRMATION_TITLE',
    /**
     * @value Edit broadcast
     * @description Label of a button that open a broadcast form to perfom some changes
     */
    EDIT_BROADCAST = 'BROADCASTS.EDIT_BROADCAST',
    /**
     * @value This page gives you access to all created broadcasts
     * @description Text to be displayed when the broadcasts list is empty
     *
     * "broadcast" is a product name, it should not be translated.
     */
    EMPTY_STATE_DESCRIPTION = 'BROADCASTS.EMPTY_STATE_DESCRIPTION',
    /**
     * @value Use the calendar or click the button to load previous broadcasts
     * @description A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    EMPTY_STATE_DESCRIPTION_TIMELINE = 'BROADCASTS.EMPTY_STATE_DESCRIPTION_TIMELINE',
    /**
     * @value There are no broadcasts
     * @description Text to be displayed when the broadcasts lists is empty
     *
     * "Broadcast" is a product name, it should not be translated
     */
    EMPTY_STATE_TITLE = 'BROADCASTS.EMPTY_STATE_TITLE',
    /**
     * @value There are no broadcasts after this date
     * @description A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    EMPTY_STATE_TITLE_TIMELINE = 'BROADCASTS.EMPTY_STATE_TITLE_TIMELINE',
    /**
     * @value Fields are required to send the broadcast
     * @description "broadcast" is a product name, it should not be translated
     */
    FIELDS_REQUIRED = 'BROADCASTS.FIELDS_REQUIRED',
    /**
     * @value Link to a campaign
     * @description "Link" is a verb here, also here, "link" does not mean "attach", it is the action to create a relation between two elements (a broadcast and a campaign in our case)
     */
    LINK_TO_CAMPAIGN = 'BROADCASTS.LINK_TO_CAMPAIGN',
    /**
     * @value New broadcast
     * @description Call to create a new broadcast
     *
     * "Broadcast" is a product name, it should not be translated
     */
    NEW_BROADCAST = 'BROADCASTS.NEW_BROADCAST',
    /**
     * @value Next broadcasts
     * @description Text of a button that will show the next broadcasts when clicked (= the ones planned after the last one currently visible)
     */
    NEXT_BROADCASTS = 'BROADCASTS.NEXT_BROADCASTS',
    /**
     * @value No audience has been defined
     * @description Helper text used as a placeholder to tell the user that she doesn't have defined an audience (group of segments = people who will receive the notification) in her broadcast yet
     */
    NO_AUDIENCE_SET = 'BROADCASTS.NO_AUDIENCE_SET',
    /**
     * @value This page shows you all data available for this broadcast once it is sent.
     * @description Text displayed on a broadcast insights page when the broadcast has not been sent yet and therefor has no insights.
     *
     * "Broadcast" is a product name, it should not be translated
     */
    NO_INSIGHTS_DESCRIPTION = 'BROADCASTS.NO_INSIGHTS_DESCRIPTION',
    /**
     * @value No schedule date has been set
     */
    NO_SCHEDULE_SET = 'BROADCASTS.NO_SCHEDULE_SET',
    /**
     * @value Open broadcast
     * @description expand button label in broadcast drawer when you wanna see it in full page mode
     */
    OPEN_BROADCAST = 'BROADCASTS.OPEN_BROADCAST',
    /**
     * @value Previous broadcasts
     * @description Text of a button that will show the previous broadcasts when clicked (= the ones planned before the last one currently visible)
     *
     */
    PREVIOUS_BROADCASTS = 'BROADCASTS.PREVIOUS_BROADCASTS',
    /**
     * @value Projected sending date %DATE%
     * @description In broadcast, if the sending date is related to a campaign baseline date, the sending date is calculated and displayed
     */
    PROJECTED_SENDING_DATE = 'BROADCASTS.PROJECTED_SENDING_DATE',
    /**
     * @value Resource unavailable
     * @description Text of a notification to let the user know that the selected resource cannot be used because it is not available.
     */
    RESOURCE_UNAVAILABLE = 'BROADCASTS.RESOURCE_UNAVAILABLE',
    /**
     * @value Save as template
     * @description Menu entry and tooltip text to save a community's settings as a template to create other communites
     */
    SAVE_AS_TEMPLATE = 'COMMUNITIES_ADMIN.SAVE_AS_TEMPLATE',
    /**
     * @value Schedule broadcast?
     * @description Text displayed to demand confirmation for scheduling a broadcast
     *
     * "Broadcast" is a product name, it should not be translated
     */
    SCHEDULE_BROADCAST_QUESTION = 'BROADCASTS.SCHEDULE_BROADCAST_QUESTION',
    /**
     * @value Schedule date
     * @description Text to be displayed when showing the schedule date of a broadcast
     *
     * "Schedule" is not a verb here, it relates to "date"
     */
    SCHEDULE_DATE = 'BROADCASTS.SCHEDULE_DATE',
    /**
     * @value Approximately on %DATE%
     */
    SCHEDULE_DATE_ON = 'BROADCASTS.SCHEDULE_DATE_ON',
    /**
     * @value Schedule the broadcast
     * @description Used as a section title
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    SCHEDULE_THE_BROADCAST = 'BROADCASTS.SCHEDULE_THE_BROADCAST',
    /**
     * @value Choose the date and time, or schedule the broadcast based on a campaign baseline event.
     * @description A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     *
     * A campaign is used to communicate with employees by sending them a set of notifications.
     *
     * A baseline date is a date that is set and can be used as a base to define another date.
     *
     * For example a baseline date can be a project's start date (for example, 10th of August). You could use this as a base date to define a meeting date which is one week after the project start date (which would be the 17th of August for our example).
     */
    SCHEDULING_DESCRIPTION = 'BROADCASTS.SCHEDULING_DESCRIPTION',
    /**
     * @value Sending will start immediately. Users may receive the notification with some delay.
     */
    SENDING_IMMEDIATELY_MESSAGE = 'BROADCASTS.SENDING_IMMEDIATELY_MESSAGE',
    /**
     * @value Sending is in progress
     * @description Notification message to display after the broadcast has been successfully scheduled to be sent immediately
     */
    SENDING_IN_PROGRESS = 'BROADCASTS.SENDING_IN_PROGRESS',
    /**
     * @value Send broadcast?
     * @description Send broadcast confirmation question
     *
     * "Broadcast" is a product name, it should not be translated.
     */
    SEND_BROADCAST_QUESTION = 'BROADCASTS.SEND_BROADCAST_QUESTION',
    /**
     * @value Send immediately
     */
    SEND_IMMEDIATELY = 'BROADCASTS.SEND_IMMEDIATELY',
    /**
     * @value Broadcast your resource right away while you save your work.
     * @description A helper to let the user know what will happen if she selects the corresponding scheduling option
     *
     * Here a "resource" can be a website URL, an article, etc. something that can be opened and read by a user.
     *
     * The resource will be "broadcasted" to some users via a notification (an email, ...)
     */
    SEND_IMMEDIATELY_HELPER = 'BROADCASTS.SEND_IMMEDIATELY_HELPER',
    /**
     * @value Send relatively to a baseline date
     * @description Option to schedule a broadcast based on a campaign baseline event
     *
     * A baseline date is a date that is set and can be used as a base to define another date.
     *
     * For example a baseline date can be a project's start date (for example, 10th of August). You could use this as a base date to define a meeting date which is one week after the project start date (which would be the 17th of August for our example).
     */
    SEND_RELATIVELY_TO_BASELINE_DATE = 'BROADCASTS.SEND_RELATIVELY_TO_BASELINE_DATE',
    /**
     * @value Broadcasts settings
     * @description Title of the page where users can manage settings of the journey feature
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    SETTINGS = 'BROADCASTS.SETTINGS',
    /**
     * @value All broadcasts
     * @description /!\ PLEASE DO NOT TRANSLATE THE WORD BROADCAST! It's a feature's name that should be transcribed as is.
     *
     * Title of a button in a menu. Clicking it will display a page with all broadcasts.
     */
    SIDE_NAV_TITLE = 'BROADCASTS.SIDE_NAV_TITLE',
    /**
     * @value All tags created below will also be available in the platform.
     */
    TAGZ_INFORMATION_MESSAGE = 'BROADCASTS.TAGZ_INFORMATION_MESSAGE',
    /**
     * @value Broadcasts
     * @description Title of the "broadcasts" section and page
     *
     * "Broadcast" is a product name, it should not be translated
     */
    TITLE = 'BROADCASTS.TITLE',
    /**
     * @value Name your broadcast
     * @description Placeholder for a broadcast's title field in the sub-section form
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    TITLE_PLACEHOLDER = 'BROADCASTS.TITLE_TITLE_PLACEHOLDER',
    /**
     * @value View "%BROADCAST_NAME%" broadcast details
     * @description The label of a link to that opens the broadcast page for screen reader. For example "View 'Last arrivals' broadcast details". "View" is a verb here
     *
     * A "broadcast" is a communication sent via a channel (email, mobile push notification, etc.) to a group of people.
     */
    VIEW_BROADCAST_DETAILS = 'BROADCASTS.VIEW_BROADCAST_DETAILS',
}
